import React, { useEffect } from "react";
import { companyLogo, closeIcon, IllustrationMagic } from "assets";
import { Button } from "core/controls";
import { Modal } from "core/uicore";
import { usePCTranslation } from "core/hooks";

const AboutModal = ({
  controlGetFocus,
  controlLostFocus,
  controlClick,
  onCancel,
  setElement,
  route,
}) => {
  const { t } = usePCTranslation();

  useEffect(() => {
    document.body.classList.add('modalFont');
  }, [])
  


  return (
    <Modal onClick={(e) => e.stopPropagation()} propStyle="modalDark">
      <div className="modalcontainerFull paddingLg borderRadiusAllLg">
        <Button
          text="Cancel"
          getfocusCallback={controlGetFocus}
          getclickCallback={(event, name, value) => {
            controlClick(event, name, value);
            onCancel();
          }}
          lostfocusCallback={controlLostFocus}
          name="btnXAboutCancel"
          refItem={setElement}
          propStyle={{
            label: "buttonlabel",
            control: `modalClose`,
          }}
          logo={{
            srcLogo: closeIcon,
            altLogo: "",
            classLogo: "close-logo",
          }}
          showIcon={true}
        />
        <div className="modalContainer">
          <div
            className="flexContainer"
            style={{ width: "10rem", margin: "1.2rem auto" }}
          >
            <svg
              width="117"
              height="35"
              viewBox="0 0 117 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M83.3317 13.9225C82.9318 13.6885 82.5066 13.5004 82.0643 13.3621C81.607 13.2218 81.131 13.1522 80.6526 13.1555C79.6945 13.1212 78.7676 13.4986 78.1059 14.1922C77.4063 15.0013 77.0521 16.0525 77.1193 17.12C77.1106 17.687 77.1949 18.2517 77.3689 18.7914C77.5186 19.255 77.7623 19.6827 78.0848 20.0477C78.3954 20.3942 78.7785 20.668 79.2068 20.8499C79.6706 21.0418 80.1687 21.137 80.6707 21.1296C81.1816 21.1321 81.6896 21.0515 82.1746 20.891C82.6131 20.7524 83.0241 20.5383 83.3888 20.2583L83.6385 21.4825C83.2201 21.7377 82.7649 21.927 82.2889 22.044C81.7463 22.1839 81.1879 22.2537 80.6275 22.2516C79.957 22.2602 79.2909 22.1404 78.6654 21.8986C78.0944 21.6724 77.5802 21.3232 77.1594 20.8759C76.7287 20.4129 76.3968 19.8671 76.1838 19.2717C75.7165 17.898 75.72 16.4079 76.1938 15.0365C76.412 14.434 76.7512 13.8826 77.1905 13.4162C77.6196 12.9743 78.1363 12.627 78.7075 12.3965C79.3243 12.1488 79.9839 12.0252 80.6486 12.0325C81.22 12.0297 81.7892 12.1032 82.3411 12.2511C82.8255 12.3764 83.2901 12.5684 83.7217 12.8216L83.3317 13.9225ZM73.9256 17.0993C73.9334 17.8063 73.8104 18.5086 73.5626 19.1708C73.3351 19.7762 72.9891 20.3301 72.5449 20.8001C72.1073 21.2579 71.5809 21.6216 70.9978 21.8689C70.3804 22.13 69.7159 22.261 69.0457 22.254C68.3847 22.2598 67.729 22.1362 67.1155 21.89C66.5357 21.6559 66.0107 21.3043 65.5735 20.8573C65.125 20.3962 64.775 19.8486 64.5448 19.248C64.2894 18.5837 64.1621 17.8771 64.1698 17.1655C64.1619 16.4602 64.285 15.7595 64.5327 15.099C64.98 13.8897 65.9087 12.92 67.0975 12.4209C67.7146 12.1603 68.3788 12.0292 69.0487 12.0359C69.7099 12.0306 70.3658 12.1542 70.9798 12.3999C72.1657 12.8693 73.0999 13.8152 73.5546 15.0068C73.8109 15.6742 73.9368 16.3845 73.9256 17.0993ZM72.6387 17.1651C72.6469 16.603 72.5556 16.0439 72.369 15.5137C72.2044 15.0476 71.9515 14.6176 71.624 14.2474C71.3079 13.8955 70.9198 13.6158 70.486 13.4272C70.0213 13.229 69.5203 13.1299 69.0151 13.1364C68.5241 13.1326 68.0377 13.2316 67.5873 13.4272C67.1572 13.613 66.7721 13.8893 66.4583 14.2373C66.1349 14.605 65.8854 15.0315 65.7234 15.4936C65.5404 16.0085 65.4494 16.5515 65.4547 17.0979C65.4473 17.6631 65.5382 18.2252 65.7234 18.7593C65.8871 19.2312 66.1442 19.6653 66.4794 20.0357C66.8005 20.3868 67.192 20.6663 67.6284 20.8558C68.5558 21.2435 69.5998 21.2435 70.5271 20.8558C70.959 20.6689 71.3441 20.3889 71.6551 20.0357C71.9747 19.667 72.2208 19.2406 72.38 18.7793C72.5578 18.26 72.6453 17.714 72.6387 17.1651ZM51.8008 17.8566C52.5435 17.2467 52.9427 16.3133 52.8707 15.355C52.8974 14.5037 52.5483 13.6838 51.9161 13.1131C51.0901 12.469 50.0527 12.1578 49.0085 12.2407H46.1218V22.0417H47.3882V18.6978H48.842C49.8935 18.7466 50.9323 18.4513 51.8008 17.8566ZM48.9256 13.4042C50.6976 13.4036 51.5836 14.075 51.5836 15.4186C51.5836 16.8022 50.6976 17.5081 48.9256 17.5362L47.3684 17.5562V13.4042H48.9256ZM55.2172 22.0403H56.4836V18.4679L58.7465 18.3435L61.0316 22.0403H62.4824L59.9908 18.0528C60.5505 17.848 61.0426 17.4923 61.4126 17.025C61.7978 16.5078 61.9926 15.8735 61.9641 15.2293C62.0037 14.3961 61.6607 13.5904 61.0326 13.0415C60.222 12.4487 59.2266 12.1643 58.2252 12.2394H55.2172V22.0403ZM60.0486 16.7809C59.5197 17.1676 58.8742 17.3611 58.2197 17.3294L56.4631 17.3665V13.405H58.1165C58.7965 13.3523 59.4759 13.5147 60.0586 13.8692C60.4918 14.2236 60.7234 14.7682 60.6783 15.3261C60.7058 15.8825 60.4731 16.4201 60.0486 16.7809ZM95.1671 17.0999C95.1751 17.8069 95.0517 18.5094 94.8031 19.1713C94.5764 19.7769 94.2307 20.3309 93.7864 20.8007C93.3497 21.2564 92.8247 21.6184 92.2434 21.8645C91.626 22.1255 90.9615 22.2566 90.2912 22.2495C89.6299 22.2554 88.9739 22.1317 88.3601 21.8855C87.7791 21.6533 87.2523 21.3034 86.813 20.8578C86.3651 20.3964 86.0155 19.8489 85.7853 19.2485C85.5292 18.5844 85.4013 17.8778 85.4083 17.166C85.4005 16.4607 85.5235 15.76 85.7713 15.0996C86.2163 13.889 87.1441 12.9176 88.333 12.4175C88.9505 12.1569 89.615 12.0259 90.2852 12.0325C90.9464 12.0271 91.6024 12.1507 92.2163 12.3964C93.4022 12.8658 94.3364 13.8117 94.7911 15.0033C95.0496 15.6716 95.1773 16.3834 95.1671 17.0999ZM93.881 17.1663C93.8887 16.6043 93.7974 16.0453 93.6112 15.5149C93.4471 15.0486 93.1941 14.6186 92.8663 14.2486C92.5498 13.8967 92.1613 13.617 91.7273 13.4284C91.2629 13.2302 90.7622 13.1312 90.2574 13.1376C89.7661 13.1339 89.2794 13.233 88.8286 13.4284C88.3988 13.6143 88.014 13.8906 87.7006 14.2386C87.3769 14.606 87.1273 15.0326 86.9657 15.4949C86.7823 16.0097 86.691 16.5527 86.696 17.0991C86.6889 17.6644 86.7802 18.2265 86.9657 18.7605C87.129 19.2326 87.3861 19.6668 87.7217 20.0369C88.0428 20.388 88.4343 20.6675 88.8707 20.8571C89.798 21.2447 90.842 21.2447 91.7694 20.8571C92.2012 20.6702 92.5864 20.3901 92.8974 20.0369C93.2174 19.6685 93.4635 19.242 93.6223 18.7806C93.8001 18.2612 93.8876 17.7152 93.881 17.1663ZM106.282 22.0415L106.115 13.8809L103.125 22.0415H101.77L98.7396 13.8569L98.5742 22.0385H97.3279L97.6397 12.2376H99.3833L102.478 20.6468L105.509 12.2376H107.232L107.544 22.0385L106.282 22.0415ZM116.992 15.355C117.064 16.3131 116.665 17.2463 115.923 17.8566C115.054 18.4512 114.015 18.7465 112.963 18.6978H111.51V22.0417H110.243V12.2407H113.129C114.174 12.1578 115.211 12.469 116.037 13.1131C116.669 13.6838 117.018 14.5037 116.992 15.355ZM115.705 15.4186C115.705 14.075 114.819 13.4036 113.047 13.4042H111.49V17.5562L113.047 17.5362C114.82 17.5081 115.707 16.8022 115.707 15.4186H115.705Z"
                fill="#333333"
              />
              <path
                d="M16.4585 18.511C16.458 18.2005 16.7086 17.9481 17.019 17.9465H19.6109C19.9209 17.9487 20.1709 18.2009 20.1703 18.511V31.5063L23.1492 29.7727V10.7655C23.1503 10.4641 23.3943 10.2201 23.6957 10.219H26.3206C26.6222 10.2196 26.8665 10.4639 26.8671 10.7655V27.61L29.9432 25.8193L29.882 8.57367L14.9084 0L0 8.67795L0.0611617 25.9236L3.07614 27.6501V23.2475C3.07778 22.9464 3.32147 22.7027 3.62258 22.701H6.24251C6.54362 22.7027 6.78731 22.9464 6.78895 23.2475V29.7788L9.76683 31.4833V14.0973C9.76683 13.7965 10.0135 14.6919 10.3133 14.6919H12.9332C13.2348 14.6924 13.4791 14.9367 13.4796 15.2383V33.6109L15.0308 34.4982L16.4585 33.667V18.511Z"
                fill="#333333"
              />
            </svg>
          </div>
          <div className="flexContainer twoCol" style={{ width: "110%" }}>
            <div>
              <div>
                <h2
                  style={{
                    color: "#1791B0",
                    fontSize: "2.6rem",
                    fontWeight: "bold",
                  }}
                >
                  Hello!
                </h2>
                <h3 style={{ color: "#1791B0", fontSize: "2rem" }}>
                  We are Procomp consulting
                </h3>
              </div>
              <p style={{ padding: "1rem 0", color: "#333333" }}>
                We combine acturial and IT expertise to provide you with the
                products or people to meet your insurance products needs.
              </p>
              <div>
                <p
                  className="fontBold"
                  style={{ paddingTop: "0.5rem", color: "#333333" }}
                >
                  {`${t("CompanyName")} Help Desk`}
                </p>
                <p style={{ paddingTop: "0.5rem" }}>
                  <span className="fontBold">{t("Choice-Phone")}</span> (519)
                  886-4610x321
                </p>
                <p style={{ paddingTop: "0.5rem" }}>
                  <span className="fontBold">Toll free</span> 1-800-563-6237
                  x321
                </p>
                <p style={{ paddingTop: "0.5rem" }}>
                  <span className="fontBold">{t("Choice-Email")}</span>{" "}
                  {t("CompanyEmail")}
                </p>
              </div>
            </div>
            <div>
              <img className="about-logo" src={IllustrationMagic} alt="" />
            </div>
          </div>
          <div className="flexContainer alignCenter">
            <div style={{ marginRight: "20px" }}>
              <a
                style={{ color: "#1791B0" }}
                href="https://procompconsulting.ca"
                target="_blank"
              >
                procompconsulting.ca
              </a>
            </div>
            <div style={{ textAlign: "center" }}>
              <p>
                ProCloud Illustration System
                <span
                  style={{
                    margin: "0 0.5rem 2px",
                    height: "5px",
                    width: "5px",
                    borderRadius: "50%",
                    backgroundColor: "#6B6E70",
                    display: "inline-block",
                  }}
                ></span>
                <span style={{ color: "#6B6E70" }}>(905) 640-2667</span>
              </p>
              <p style={{ fontSize: "0.85rem" }}>
                Copyright &copy; 2015-2022, ProComp Consulting Inc. All rights
                reserved
              </p>
              <p style={{ fontSize: "0.85rem" }}>
                Version {process.env.REACT_APP_VERSION}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AboutModal;
